module.exports = __webpack_public_path__ + "media/images/icons/sort-ascending-3d485559f7fa50430f99b4f76a4fa285.svg";